<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

interface PolicyMiniItem {
	label: string
	text: string
}

interface PolicyItem {
	label: string
	text: string
	mini?: PolicyMiniItem[]
}

interface PolicySection {
	title?: string
	text?: string
	items?: PolicyItem[]
	passage?: string
}

const { tm, t } = useI18n()
const sections = computed(() => tm('WarrantyPolicy.sections') as unknown as PolicySection[])
</script>

<template>
	<div class="body">
		<article>
			<!-- 标题 -->
			<h2 class="title">{{ t('WarrantyPolicy.title') }}</h2>
			<!-- 正文 -->
			<div class="text">{{ t('WarrantyPolicy.intro') }}</div>
			<div class="sort" v-for="(section, index) in sections" :key="index">
				<div class="sort-number">{{ index + 1 }}.</div>
				<div class="value">
					<div class="content">
						<strong v-if="section.title">{{ section.title }}</strong>
						<span v-if="section.text" v-html="section.text"></span>
					</div>
					<div class="sort-small" v-for="item in section.items || []" :key="item.label">
						<div class="sort-small-number">{{ item.label }}</div>
						<div class="value">
							<span v-html="item.text"></span>
							<div class="sort-mini" v-for="mini in item.mini || []" :key="mini.label">
								<div class="sort-mini-number">{{ mini.label }}</div>
								<span v-html="mini.text"></span>
							</div>
						</div>
					</div>
					<div class="passage" v-if="section.passage" v-html="section.passage"></div>
				</div>
			</div>
		</article>
	</div>
</template>

<style lang='scss' scoped>
.body {
	padding: 40px 24px;
	display: flex;
	justify-content: center;
	width: 100%;
	background: #F2F2F2;

	article {
		width: 100%;
		max-width: 960px;
		padding: 64px 40px;
		align-self: stretch;
		font-family: PingFang SC;
		border-radius: 16px;
		background: #FFF;

		.title {
			color: #000;
			font-size: 32px;
			font-style: normal;
			font-weight: 600;
			line-height: normal;
		}

		strong {
			font-weight: 600;
		}

		.text {
			margin-top: 16px;
			font-weight: 500;
			line-height: 27px;
			color: #000;
			font-size: 18px;
			font-style: normal;
			font-weight: 400;
			line-height: 27px;
		}

		.sort {
			margin-top: 16px;
			display: flex;
			color: #000;
			font-size: 18px;
			font-style: normal;
			font-weight: 400;

			.sort-number {
				width: 32px;
				margin-right: 16px;
				text-align: center;
				flex-shrink: 0;
			}

			.value {
				.content {
					padding-bottom: 8px;
				}
			}

			.passage {
				margin-top: 16px;
				padding-bottom: 8px;
				flex-shrink: 0;
			}
		}

		.sort-small {
			margin-top: 8px;
			padding-bottom: 8px;
			display: flex;
			color: #000;
			font-size: 16px;
			font-style: normal;
			font-weight: 400;
			line-height: 24px;

			.sort-small-number {
				width: 32px;
				margin-left: -8px;
				margin-right: 16px;
				text-align: center;
				flex-shrink: 0;
			}

			.sort-mini {
				margin-top: 8px;
				padding-bottom: 8px;
				display: flex;
				color: #000;
				font-family: PingFang SC;
				font-size: 16px;
				font-style: normal;
				font-weight: 400;
				line-height: 24px;

				.sort-mini-number {
					width: 32px;
					margin-left: -8px;
					margin-right: 16px;
					text-align: center;
					flex-shrink: 0;
				}
			}
		}
	}
}
</style>
